import React from 'react';
import {
  Modal,
  ModalBody
} from 'reactstrap';
import { Warning } from '../../../assets/images';

type AppProps = {
  isOpen: boolean;
  toggle?: () => void;
  title?: string;
  message?: any;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onPressConfirm?: () => void;
}

const ConfirmationModal = ({
  isOpen,
  toggle,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  onPressConfirm
}: AppProps) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
      >
        <ModalBody className='p-4'>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={Warning} alt="Warning sign" />
            <h3 className='mt-2 mb-3'>{title}</h3>
            <h4 className='text-center'>{message}</h4>
          </div>
          <div className="d-flex justify-content-center pt-2 pb-2">
            <button className='btn btn-primary mr-5' onClick={onPressConfirm}>
              {confirmButtonText ?? 'Delete'}
            </button>
            <button className='btn btn-outline' onClick={toggle}>
              {cancelButtonText ?? 'Cancel'}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
};

export default ConfirmationModal